import { render, staticRenderFns } from "./Combination.vue?vue&type=template&id=62debf95&scoped=true&"
import script from "./Combination.vue?vue&type=script&lang=js&"
export * from "./Combination.vue?vue&type=script&lang=js&"
import style0 from "./Combination.vue?vue&type=style&index=0&id=62debf95&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62debf95",
  null
  
)

export default component.exports